import { Observable } from 'rxjs/Observable';
import editPicture from '../actions/editPictureAction'

export function handleUploadPicsToUserGalleryFulfilled(action$, store) {
    return action$.filter(
        action => action.type === 'ADD_IMAGE_TO_USER_GALLERY_FULFILLED')
        .mergeMap(() => Observable.merge(
            Observable.of(editPicture(store.getState().user.picType, store.getState().user.data, store.getState().user.imageUrl,
                store.getState().templates.currentTemplate, store.getState().events.currentEvent),
            )))
}



// WEBPACK FOOTER //
// ./src/epics/uploadPicsToUserGalleryEpic.js